import type {
  DeliveryChannel,
  MediaAsset,
  PublishedMeta,
  RightsLevel
} from './types'

const customerFacingChannels = new Set<DeliveryChannel>([
  'windows_demo',
  'wecom_h5_internal',
  'solution_preview',
  'pdf_export',
  'image_export'
])

export function isExpired(expiresAt: string | null, now = new Date()): boolean {
  if (expiresAt === null) return false
  const timestamp = Date.parse(expiresAt)
  return Number.isNaN(timestamp) || timestamp < now.getTime()
}

export function rightsAllowCustomerUse(
  rightsLevel: RightsLevel,
  channel: DeliveryChannel
): boolean {
  if (!customerFacingChannels.has(channel)) return false
  return rightsLevel === 'public' || rightsLevel === 'customer-demo'
}

export function canUseOnChannel(
  item: Pick<PublishedMeta | MediaAsset, 'rightsLevel' | 'allowedChannels'> & {
    expiresAt?: string | null
  },
  channel: DeliveryChannel,
  now = new Date()
): boolean {
  if (!rightsAllowCustomerUse(item.rightsLevel, channel)) return false
  if (!item.allowedChannels.includes(channel)) return false
  if ('expiresAt' in item && item.expiresAt !== undefined && isExpired(item.expiresAt, now)) {
    return false
  }
  return true
}

